import { reactive } from "vue";
import {lang} from "../localize/localize.js";

export function createStoreInstance() {
  return reactive({
    name: "", // name of the calculator ex: loan, cash...

    calcModel: {
      age: 0,
      tenor: 0,
    }, // model to Save all input values
    calcFields: [
      {
        id: -2,
        type: undefined,
        allow_empty: undefined,
        place_holder: undefined,
      },
    ], // stores all fields
    calcTitles: {
      result_title: "",
      currency: "",
      disclaimer: "",
      form_button: "",
    }, // stores form titles, currency, disclamer, submit button title

    Response: {
      validation_code: -2,
      qualified: -2,
      discounted_monthly_installment: "",
      unqualified_msg: "",
      limit_msg: "",
      monthly_limit: "",
    }, // stores responses that result from API fetch

    loanAmountVRs: [], // stores resseter rules specifically loanAmount
    resetterCache: {}, // stores resseter min max for each field

    validationSchema: {},
    formError: true,

    dropDownOptions: {}, // for Select field
    NewNoteMsg: {}, // for Note field

    maxValueOfAgeSlider: null, // for Slider field
    maxValueOfTenorSlider: null, // for Slider field
    minValueOfTenorSlider: null, // for Slider field

    comma: {}, // for Number field

    automaticCalc: [], // stores automatic calculation result
    automaticCalcResult: {}, // stores automatic calculation result

    token: "", // login api
    lang: "en", // lang comes from lang the global variable
    productItem: false, // for product item
    submitted: false, // stores form submition state
    loading: true, // stores form loading state
    flag: false,

    undefined: undefined, // to be removed

    getURL: "",
    postURL: "",

    SetURL(url) {
      const getURL = new URL(url + "form");
      if (this.productItem) {
        getURL.searchParams.append("product_item", this.productItem)
      }
      getURL.searchParams.append("lang", this.lang);
      this.getURL = getURL;

      const postURL = new URL(url + "submit");
      postURL.searchParams.append("lang", this.lang);
      if (this.productItem) {
        postURL.searchParams.append("product_item", this.productItem);
      }
      this.postURL = postURL;
    },
    setLang(newValue) {
      this.lang = newValue;
      lang(newValue);
    },
    setProductItem(newValue) {
      this.productItem = Number(newValue);
    },
    setFlag(newValue) {
      this.flag = newValue;
    },
    setMaxValueOfAgeSlider(newValue) {
      this.maxValueOfAgeSlider = newValue;
    },
    setMaxValueOfTenorSlider(newValue) {
      this.maxValueOfTenorSlider = newValue;
    },
    setMinValueOfTenorSlider(newValue) {
      this.minValueOfTenorSlider = newValue;
    },
    setDropDownOptions(newValue) {
      this.dropDownOptions = newValue;
    },
    addDropDownOptions(newValue) {
      this.dropDownOptions.push(newValue);
    },
    setNewNoteMsg(newValue) {
      this.NewNoteMsg = newValue;
    },
    setName(newValue) {
      this.name = newValue;
    },
    setLoading(newValue) {
      this.loading = newValue;
    },
    setCalcFields(newValue) {
      this.calcFields = newValue;
    },
    setCalcTitles(newValue) {
      this.calcTitles = newValue;
    },
    setAutomaticCalc(newValue) {
      newValue.map((autoCalc)=>{
        autoCalc.result
        this.automaticCalcResult[autoCalc.result] = -1;
        autoCalc.args.map(arg=>{
          this.automaticCalc[arg] = autoCalc;
        });
      });
    },
    setResetterCache(name, value) {
      this.resetterCache[name] = value;
    },
    setSubmitted(newValue) {
      this.submitted = newValue;
    },
    setResponse(newValue) {
      this.Response = newValue;
    },
    emptyResponse() {
      this.Response = [];
    },
    emptyDropDownOptions() {
      this.dropDownOptions = [];
    },
    ProfessionsOnChange() {
      const name = this.name;
      const programID = this.calcModel[name + "_programs"];
      const programIndex = this.loanAmountVRs.findIndex((loanAmountVR) => {
        const fieldValuePair = loanAmountVR.field_value_pairs[0];
        return (
          fieldValuePair.field == name + "_programs" &&
          programID == fieldValuePair.value
        );
      });

      let min = this.loanAmountVRs[programIndex]?.min || 0;
      let max = this.loanAmountVRs[programIndex]?.max || 0;
      this.setFlag(false);

      const professionID = this.calcModel[name + "_professions"];
      const professionIndex = this.loanAmountVRs.findIndex(function (
        loanAmountVR
      ) {
        const ProfessionFieldValuePair = loanAmountVR.field_value_pairs[0];
        const ProgramFieldValuePair = loanAmountVR.field_value_pairs[1];
        return (
          ProfessionFieldValuePair.field == name + "_professions" &&
          professionID == ProfessionFieldValuePair.value &&
          ProgramFieldValuePair.field == name + "_programs" &&
          programID == ProgramFieldValuePair.value
        );
      });

      if (professionIndex >= 0) {
        min = this.loanAmountVRs[professionIndex].min;
        max = this.loanAmountVRs[professionIndex].max;
        this.setFlag(true);
      }

      this.setResetterCache(name + "_loan_amount_min", min);
      this.setResetterCache(name + "_loan_amount_max", max);
    },
    resetAField(currentResetter, tregerdFieldID, fieldID, fieldType) {

          const newValues = currentResetter.new_values;

          if (fieldType == "select" || fieldType == "slider-stepper") {
            newValues.map((newValuesObj) => {
              this.addDropDownOptions({ fieldID, newValuesObj });
            });
          } else if (fieldType == "note") {
            const msg = newValues[0].value;
            this.setNewNoteMsg({ fieldID, msg });
          } else if (fieldType == "slider") {
            this.setResetterCache(fieldID + "_min", currentResetter.min);
            this.setResetterCache(fieldID + "_max", currentResetter.max);
          }
    },
    async onSubmit(FormData, scrollto, token) {
      this.setSubmitted(true); // why say submitted before acutally submitting?
      // validate begin
      if (!this.formError) {
        this.setLoading(true); // loading begin
        this.setSubmitted(false); //
        let payload = { ...FormData, ...this.calcModel, product: this.productItem };
        
         console.log('store:', token);
         console.log({...FormData}, {...this.calcModel})
        console.log({...payload})
        // send POST request to Submit the form
         console.log('Authorization:', localStorage.getItem('token'))
        // await getToken();
        fetch(this.postURL, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": token
          },
          method: "POST",
          body: JSON.stringify(payload)
        })
          .then((res) => res.json())
          .then((response) => {
            if(response){
              this.setResponse(response.data);

              document.querySelector('[productitem="'+this.productItem+'"].calculator .loan-calc-result')
                .scrollIntoView({behavior:'smooth'});

              if (response.status == 200) {
                return this.Response;
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.setResponse(error.response?.data);

            if (error.response?.status == 422) {
              return this.Response;
            }
          })
          .finally(() => {
            this.setLoading(false); // loading done
            if (scrollto) {
              scrollto
                .querySelector(".result-column")
                .scrollIntoView({ behavior: "smooth" });
            }
          });
      }
    },
  });
}
